export const reorderContentRows = (contentRows, dataOrder, dataType, reversedDataOrder) => {
  if (dataType === "users") return reorderUsers(contentRows, dataOrder, reversedDataOrder);
};

const reorderUsers = (contentRows, dataOrder, reversedDataOrder) => {
  const cellUser = (row) => row.cells.find((c) => c.value === "user_block").user;

  if (dataOrder === "firstname_a") {
    return [...contentRows].sort((a, b) => cellUser(a).first_name.localeCompare(cellUser(b).first_name));
  } else if (dataOrder === "firstname_z") {
    return [...contentRows].sort((a, b) => cellUser(b).first_name.localeCompare(cellUser(a).first_name));
  } else if (dataOrder === "lastname_a") {
    return [...contentRows].sort((a, b) => cellUser(a).last_name.localeCompare(cellUser(b).last_name));
  } else if (dataOrder === "lastname_z") {
    return [...contentRows].sort((a, b) => cellUser(b).last_name.localeCompare(cellUser(a).last_name));
  } else {
    return reorderTableColumn(dataOrder, contentRows, reversedDataOrder);
  }
};

const reorderTableColumn = (dataOrder, contentRows, reversedDataOrder) => {
  const cellUser = (row) => row.cells.find((c) => c.sortingField === dataOrder);

  if (reversedDataOrder) {
    return [...contentRows].sort((a, b) => cellUser(a).value - cellUser(b).value);
  } else {
    return [...contentRows].sort((a, b) => cellUser(b).value - cellUser(a).value);
  }
};
